import { render, staticRenderFns } from "./PdpRpaResults.vue?vue&type=template&id=a28a5098&"
import script from "./PdpRpaResults.vue?vue&type=script&lang=js&"
export * from "./PdpRpaResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports